import { render } from "./NoteTile.vue?vue&type=template&id=20ca39e0&scoped=true"
import script from "./NoteTile.vue?vue&type=script&lang=ts"
export * from "./NoteTile.vue?vue&type=script&lang=ts"

import "./NoteTile.vue?vue&type=style&index=0&id=20ca39e0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-20ca39e0"

export default script